import { useEffect, useMemo, useRef, useState } from "react";
import {
  Box,
  Divider,
  Grid,
  CircularProgress,
  Typography,
  // IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  tableCellClasses,
} from "@mui/material";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import SelectField from "components/Select";
import { PrimaryButton } from "components/Buttons";
import { ErrorToaster, SuccessToaster } from "components/Toaster";
import Colors from "assets/Style/Colors";
import { v4 as uuidv4 } from "uuid";
import { FontFamily } from "assets";
import InputField from "components/Input";
import UploadFile from "components/UploadFile";
import DatePicker from "components/DatePicker";
import instance from "config/axios";
import routes from "services/System/routes";
import {
  CleanTypes,
  getFileSize,
  getStandardExchangeRate,
  normalizeExchangeRate,
  // getYearMonthDateFormate,
  // numberRegex,
} from "utils";
import styled from "@emotion/styled";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import { Add } from "@mui/icons-material";

import { FiDownload } from "react-icons/fi";
// import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch } from "react-redux";
import { setUsdExchangeRate } from "redux/slices/navigationDataSlice";
import { useSelector } from "react-redux";
import FinanceServices from "services/Finance";
import { createRoot } from "react-dom/client";
import SystemServices from "services/System";
import FundTransferVoucherInvoice from "components/erp_invoices/iftVoucher";

const Row = styled(TableRow)(({ theme }) => ({
  border: 0,
}));

const Cell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    border: 0,
    textAlign: "left",
    whiteSpace: "nowrap",
    backgroundColor: Colors.primary,
    color: Colors.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    textAlign: "left",
    textWrap: "nowrap",

    ".MuiBox-root": {
      display: "flex",
      gap: "6px",
      alignItems: "center",
      justifyContent: "center",
      ".MuiBox-root": {
        cursor: "pointer",
      },
    },
    svg: {
      width: "auto",
      height: "24px",
    },
    ".MuiTypography-root": {
      textTransform: "capitalize",
      fontFamily: FontFamily.NunitoRegular,
      textWrap: "nowrap",
    },
    ".css-1ru1j9e-MuiTableCell-root ": {
      color: "#ffffff",
      textAlign: "left",
    },
    ".MuiButtonBase-root": {
      padding: "8px",
      width: "28px",
      height: "28px",
    },
  },
}));

const Input = styled("input")({
  position: "absolute",
  left: 0,
  top: 0,
  width: "100%",
  height: "100%",
  display: "block",
  opacity: 0,
  fontSize: 0,
  cursor: "pointer",
  zIndex: 1,
});

const HiddenInput = styled("input")({ display: "none" });

const CreateIftv2 = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    control,
    reset,
    getValues,
  } = useForm();

  const navigate = useNavigate();
  const { usdExchangeRate } = useSelector((state) => state.navigationReducer);
  const dispatch = useDispatch();
  useEffect(() => {
    const exchangeRate = exchangeRateUsd;
    dispatch(setUsdExchangeRate(exchangeRate));
  }, []);

  const [loading, setLoading] = useState(false);

  // *For Accounts
  const [selectedFromAccount, setSelectedFromAccount] = useState(null);
  const [selectedToAccount, setSelectedToAccount] = useState(null);
  const [fromAccounts, setFromAccounts] = useState([]);
  const [toAccounts, setToAccounts] = useState([]);
  const [fromAccountsPage, setFromAccountsPage] = useState(1);
  const [toAccountsPage, setToAccountsPage] = useState(1);
  const [fromAccountsHasMore, setFromAccountsHasMore] = useState(true);
  const [toAccountsHasMore, setToAccountsHasMore] = useState(true);
  const [fromAccountsSearch, setFromAccountsSearch] = useState("");
  const [toAccountsSearch, setToAccountsSearch] = useState("");
  const [fromAccountsLoading, setFromAccountsLoading] = useState(false);
  const [toAccountsLoading, setToAccountsLoading] = useState(false);

  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);

  const [walletAccounts, setWalletAccounts] = useState([]);
  const [vaultAccounts, setVaultAccounts] = useState([]);
  const [walletAccountsLoaded, setWalletAccountsLoaded] = useState(false);
  const walletAccountsRequestRef = useRef(false);

  // *For Handle Date
  const [vaultDate, setVaultDate] = useState(new Date());

  // *For Exchange Rate Disabled
  const [disabledExchangeRate, setDisabledExchangeRate] = useState(true);
  const [exchangeRateUsd, setExchangeRateUsd] = useState();
  const [exchangeRateAed, setExchangeRateAed] = useState();
  // *For Updated Exchange Rate
  const [updateExchangeRate, setUpdateExchangeRate] = useState(0.0);

  const getStandardUsdRate = () =>
    getStandardExchangeRate(exchangeRateUsd, usdExchangeRate);

  const syncExchangeRateValue = (value) => {
    const normalizedRate = normalizeExchangeRate(value, getStandardUsdRate());
    setUpdateExchangeRate(normalizedRate);
    setValue("exchangeRate", normalizedRate);
    return normalizedRate;
  };

  // *For Transfer Amount
  const [transferAmount, setTransferAmount] = useState();
  const [rcvAmountAed, setRcvAmountAed] = useState();
  // *For Uploaded Documents
  const [progress, setProgress] = useState(0);
  const [uploadedSize, setUploadedSize] = useState(0);
  const [documentDetail, setDocumentDetail] = useState([]);
  const [documentLink, setDocumentLink] = useState("");

  const allowFilesTypeInvoice = [
    "image/png",
    "image/jpg",
    "image/jpeg",
    "application/pdf",
  ];

  const [selectedTransactionType, setSelectedTransactionType] = useState(null);
  const [selectedWalletType, setSelectedWalletType] = useState(null);
  const [selectedWalletTo, setSelectedWalletTo] = useState(null);
  const [selectedWalletFrom, setSelectedWalletFrom] = useState(null);
  const [selectedBankCashTo, setSelectedBankCashTo] = useState(null);
  const [selectedBankCashFrom, setSelectedBankCashFrom] = useState(null);

  const [selectedBankCashType, setSelectedBankCashType] = useState(null);
  const [selectedBankCashType2, setSelectedBankCashType2] = useState(null);
  const [iftvDate, setIftvDate] = useState(new Date());
  const [attachmentType, setAttachmentType] = useState();

  const [invoiceList, setInvoiceList] = useState([]);

  const [loader, setLoader] = useState(false);

  const [selectedRate, setSelectedRate] = useState({ id: 3, name: "Auto" });

  const [documentDetail2, setDocumentDetail2] = useState([]);
  const [documentLink2, setDocumentLink2] = useState("");
  const [progress2, setProgress2] = useState(0);
  const [uploadedSize2, setUploadedSize2] = useState(0);

  // *For Upload File types
  const allowFilesType = [
    "image/png",
    "image/jpg",
    "image/jpeg",
    "application/pdf",
  ];
  // *For Handle Date
  const handleVaultDate = (newDate) => {
    try {
      // eslint-disable-next-line eqeqeq
      if (newDate == "Invalid Date") {
        setVaultDate("invalid");
        return;
      }
      setVaultDate(new Date(newDate));
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const getCurrencies = async () => {
    try {
      let params = {
        detailed: true,
      };
      const { data } = await SystemServices.getCurrencies(params);
      const usdrate = data?.currencies.find(
        (e) => e.currency === "usd",
      )?.conversion_rate;
      setExchangeRateAed(
        parseFloat(
          data?.currencies.find((e) => e.currency === "aed")?.conversion_rate,
        ),
      );
      setExchangeRateUsd(parseFloat(usdrate));
      setUpdateExchangeRate(usdrate);
      setValue("exchangeRate", usdrate);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  // *For Get Voucher Branches
  const getVoucherBranches = async () => {
    try {
      const { data } = await SystemServices.getVoucherBranches();
      const branchList = data?.branches ?? [];
      setBranches(branchList);
      // *Default branch selection to UAE
      const uaeBranch = branchList.find(
        (b) => b?.name?.toLowerCase() === "uae",
      );
      if (uaeBranch) setSelectedBranch(uaeBranch);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  useEffect(() => {
    getCurrencies();
    getVoucherBranches();
  }, []);

  const buildAccountOptions = (accountRows = []) =>
    accountRows.map((account) => ({
      id: account.id,
      name: account.name,
      currency: account?.currency,
      nameKey: (account?.name || "").toLowerCase(),
    }));

  const mergeUniqueAccounts = (current, next) => {
    const map = new Map();
    [...current, ...next].forEach((account) => {
      map.set(account.id, account);
    });
    return Array.from(map.values());
  };

  const getPaymentAccounts = async ({
    page = 1,
    search = "",
    append = false,
    target,
  }) => {
    if (!target) {
      return;
    }

    const setLoadingState =
      target === "from" ? setFromAccountsLoading : setToAccountsLoading;
    const setAccountsState = target === "from" ? setFromAccounts : setToAccounts;
    const setPageState = target === "from" ? setFromAccountsPage : setToAccountsPage;
    const setHasMoreState =
      target === "from" ? setFromAccountsHasMore : setToAccountsHasMore;

    setLoadingState(true);
    try {
      let params = {
        page,
        limit: 20,
        name: search,
      };
      const { data } = await FinanceServices.getPaymentAccounts(params);

      const accountOptions = [
        ...buildAccountOptions(
          (data?.cashierAccounts?.rows || []).filter(
            (account) => account?.currency === "aed" || account?.currency === "usd",
          ),
        ),
        ...buildAccountOptions(
          (data?.bankAccounts?.rows || []).filter((account) => account?.currency),
        ),
      ];

      const totalCount =
        (Number(data?.cashierAccounts?.count) || 0) +
        (Number(data?.bankAccounts?.count) || 0);

      setAccountsState((prev) =>
        append ? mergeUniqueAccounts(prev, accountOptions) : accountOptions,
      );
      setPageState(page);
      setHasMoreState(page * 20 < totalCount);
    } catch (error) {
      ErrorToaster(error);
    } finally {
      setLoadingState(false);
    }
  };

  const getVaultCustomers = async ({ force = false } = {}) => {
    try {
      if ((walletAccountsLoaded || walletAccountsRequestRef.current) && !force) {
        return;
      }

      walletAccountsRequestRef.current = true;

      let params = {
        page: 1,
        limit: 5000,
      };
      const { data } = await FinanceServices.getVaultCustomers(params);

      const customers = data?.customers?.rows || [];
      const allAccounts = [];
      const accountOptions = [];

      customers.forEach((customer) => {
        customer?.accounts?.forEach((account) => {
          allAccounts.push(account);
          accountOptions.push({
            id: account.id,
            name: account.name,
            nameKey: account?.name || "",
          });
        });
      });

      // Set the merged accounts to state
      setWalletAccounts(allAccounts);
      setVaultAccounts(accountOptions);
      setWalletAccountsLoaded(true);
    } catch (error) {
      ErrorToaster(error);
    } finally {
      walletAccountsRequestRef.current = false;
    }
  };

  useEffect(() => {
    let timeoutId;
    let idleCallbackId;

    if (typeof window !== "undefined" && "requestIdleCallback" in window) {
      idleCallbackId = window.requestIdleCallback(() => {
        getVaultCustomers();
      });
    } else if (typeof window !== "undefined") {
      timeoutId = window.setTimeout(() => {
        getVaultCustomers();
      }, 600);
    }

    return () => {
      if (
        typeof window !== "undefined" &&
        idleCallbackId &&
        "cancelIdleCallback" in window
      ) {
        window.cancelIdleCallback(idleCallbackId);
      }

      if (timeoutId) {
        window.clearTimeout(timeoutId);
      }
    };
  }, []);

  useEffect(() => {
    if (selectedTransactionType?.id === "wallet") {
      getVaultCustomers();
    }
  }, [selectedTransactionType, walletAccountsLoaded]);

  const walletAccountGroups = useMemo(
    () => ({
      gvv: vaultAccounts.filter((account) => account.nameKey.startsWith("GVV")),
      gsv: vaultAccounts.filter((account) => account.nameKey.startsWith("GSV")),
    }),
    [vaultAccounts],
  );

  const filteredWalletFromAccounts = useMemo(() => {
    switch (selectedWalletType?.id) {
      case "vehicle to vehicle":
      case "vehicle to shipping":
        return walletAccountGroups.gvv;
      case "shipping to shipping":
      case "shipping to vehicle":
        return walletAccountGroups.gsv;
      default:
        return [];
    }
  }, [selectedWalletType, walletAccountGroups]);

  const filteredWalletToAccounts = useMemo(() => {
    switch (selectedWalletType?.id) {
      case "vehicle to vehicle":
        return walletAccountGroups.gvv;
      case "vehicle to shipping":
      case "shipping to shipping":
        return walletAccountGroups.gsv;
      case "shipping to vehicle":
        return walletAccountGroups.gvv;
      default:
        return [];
    }
  }, [selectedWalletType, walletAccountGroups]);

  const getBankCashOptions = (selection, items) => {
    if (!selection?.id) {
      return [];
    }

    const [accountType, companyType] = selection.id.split(" ");
    return items.filter((account) => {
      const accountName = account.nameKey || "";
      if (accountType === "bank" && !accountName.startsWith("guc") && !accountName.startsWith("gws")) {
        return false;
      }
      if (accountType === "cash" && !accountName.startsWith("guc") && !accountName.startsWith("gwc") && !accountName.startsWith("gws")) {
        return false;
      }

      if (companyType === "guc") {
        return accountName.startsWith("guc");
      }

      return accountName.startsWith("gws") || accountName.startsWith("gwc");
    });
  };

  const filteredFromAccounts = useMemo(
    () => getBankCashOptions(selectedBankCashType, fromAccounts),
    [selectedBankCashType, fromAccounts],
  );

  const filteredToAccounts = useMemo(
    () => getBankCashOptions(selectedBankCashType2, toAccounts),
    [selectedBankCashType2, toAccounts],
  );

  const loadMoreFromAccounts = () => {
    if (fromAccountsLoading || !fromAccountsHasMore) {
      return;
    }

    getPaymentAccounts({
      page: fromAccountsPage + 1,
      search: fromAccountsSearch,
      append: true,
      target: "from",
    });
  };

  const loadMoreToAccounts = () => {
    if (toAccountsLoading || !toAccountsHasMore) {
      return;
    }

    getPaymentAccounts({
      page: toAccountsPage + 1,
      search: toAccountsSearch,
      append: true,
      target: "to",
    });
  };

  const handleAccountsScroll = (loader) => (event) => {
    const listboxNode = event.currentTarget;
    const reachedBottom =
      listboxNode.scrollTop + listboxNode.clientHeight >=
      listboxNode.scrollHeight - 8;

    if (reachedBottom) {
      loader();
    }
  };

  useEffect(() => {
    if (!transferAmount) return;

    // Only apply cash/bank exchange-loss logic in cash/bank mode.
    // Wallet mode has its own AED conversion UI.
    if (selectedTransactionType?.id !== "cash/bank") return;

    const amount = Number(transferAmount) || 0;
    const officialAedPerUsd = Number(exchangeRateUsd) || 0;
    const enteredRate = normalizeExchangeRate(
      updateExchangeRate,
      getStandardUsdRate(),
    );
    const fromCurrency = selectedBankCashFrom?.currency?.toLowerCase?.();
    const toCurrency = selectedBankCashTo?.currency?.toLowerCase?.();

    const isSameCurrency =
      Boolean(fromCurrency) &&
      Boolean(toCurrency) &&
      fromCurrency === toCurrency;

    // Match Update IFTV behavior: no exchange rate edit when both sides share currency.
    setDisabledExchangeRate(isSameCurrency);

    const formatZeroSafe = (value, decimals) => {
      const n = Number(value) || 0;
      const eps = decimals === 2 ? 0.005 : 0.0005;
      if (Math.abs(n) < eps) return Number(0).toFixed(decimals);
      return n.toFixed(decimals);
    };

    if (isSameCurrency) {
      const receivedAmount = amount;
      const receivedAmountAed =
        fromCurrency === "usd"
          ? amount * officialAedPerUsd
          : fromCurrency === "aed"
            ? amount
            : 0;

      setValue("receivedAmountAed", Number(receivedAmountAed || 0).toFixed(2), {
        shouldDirty: false,
        shouldValidate: false,
      });
      setValue("receivedAmount", Number(receivedAmount || 0).toFixed(2), 0);
      setValue("exchangeLoss", "0.00");
      return;
    }

    const isUsdToAed = fromCurrency === "usd" && toCurrency === "aed";
    const isAedToUsd = fromCurrency === "aed" && toCurrency === "usd";

    if (!isUsdToAed && !isAedToUsd) {
      // Only USD/AED conversions are supported here.
      setValue("receivedAmount", "0.00");
      setValue("receivedAmountAed", "0.00", {
        shouldDirty: false,
        shouldValidate: false,
      });
      setValue("exchangeLoss", "0.00");
      return;
    }

    if (isUsdToAed) {
      // User may enter either:
      // - AED per USD (e.g. 3.67)
      // - USD per AED (e.g. 0.272)
      const receivedAed =
        enteredRate >= 1 ? amount * enteredRate : amount / enteredRate;
      const officialAedValue = amount * officialAedPerUsd;
      const exchangeLossAed = officialAedValue - receivedAed;

      setValue("receivedAmount", Number(receivedAed || 0).toFixed(2));
      setValue("receivedAmountAed", Number(receivedAed || 0).toFixed(2), {
        shouldDirty: false,
        shouldValidate: false,
      });
      setValue("exchangeLoss", formatZeroSafe(exchangeLossAed, 2));
      return;
    }

    // AED -> USD
    // Entered rate may be either:
    // - AED per USD (e.g. 3.674) => USD = AED / rate
    // - USD per AED (e.g. 0.272) => USD = AED * rate
    const receivedUsd =
      enteredRate >= 1 ? amount / enteredRate : amount * enteredRate;
    const receivedAedAtOfficial = receivedUsd * officialAedPerUsd;
    // Keep exchange_loss non-negative in UI
    const exchangeLossAed = Math.abs(amount - receivedAedAtOfficial);

    setValue("receivedAmount", Number(receivedUsd || 0).toFixed(2));
    setValue(
      "receivedAmountAed",
      // Keep AED base as the transferred AED amount
      Number(amount || 0).toFixed(2),
      {
        shouldDirty: false,
        shouldValidate: false,
      },
    );
    setValue("exchangeLoss", formatZeroSafe(exchangeLossAed, 2));
  }, [
    transferAmount,
    updateExchangeRate,
    exchangeRateUsd,
    selectedTransactionType,
    selectedBankCashTo,
    selectedBankCashFrom,
  ]);

  const handleIftvDate = (newDate) => {
    try {
      if (newDate == "Invalid Date") {
        setIftvDate("invalid");
        return;
      }
      setIftvDate(new Date(newDate));
      setValue("iftvDate", newDate);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const handleUploadDocumentInvoices = async (e) => {
    try {
      e.preventDefault();
      const file = e.target.files[0];
      let arr = [
        {
          id: uuidv4(),
          name: file?.name,
          file: "",
          type: file?.type.split("/")[1],
          size: getFileSize(file.size),
          isUpload: false,
        },
      ];
      if (allowFilesTypeInvoice.includes(file.type)) {
        setDocumentDetail2(arr);
        handleUploadInvoices(file, arr);
      } else {
        ErrorToaster(
          `Only ${CleanTypes(allowFilesTypeInvoice)} formats is supported`,
        );
      }
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const handleUploadInvoices = async (file, docs) => {
    setProgress(0);
    try {
      const formData = new FormData();
      formData.append("document", file);
      const { data } = await instance.post(routes.uploadDocuments, formData, {
        onUploadProgress: (progressEvent) => {
          const uploadedBytes = progressEvent.loaded;
          const percentCompleted = Math.round(
            (uploadedBytes * 100) / progressEvent.total,
          );

          setProgress2(percentCompleted);
          setUploadedSize2(getFileSize(uploadedBytes));
        },
      });
      if (data) {
        docs[0].isUpload = true;
        docs[0].file = data?.data?.nations;
        setDocumentDetail2(docs);
        setDocumentLink2(data?.data?.nations);
        SuccessToaster("Document Uploaded");
      } else {
        ErrorToaster("Document upload failed.");
      }
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const handleAddDocument = () => {
    if (!documentLink2) {
      ErrorToaster("Please upload a document before adding.");
      return;
    }

    setInvoiceList([
      ...invoiceList,
      {
        id: uuidv4(),
        attachmentType: attachmentType?.id,
        attachmentTypeName: documentDetail2?.[0]?.name,
        documentLink2,
      },
    ]);
    SuccessToaster("Document Added");
    setAttachmentType([]);
    setDocumentLink2("");
  };

  // useEffect(() => {
  //     if (documentLink2) {
  //         handleAddDocument();
  //     }
  // }, [documentLink2]);

  useEffect(() => {
    // Wallet mode: show a live AED preview for the USD transfer amount.
    if (selectedTransactionType?.id !== "wallet") return;

    const amt = Number(transferAmount || 0);
    const aed = amt * exchangeRateUsd;
    setValue("receivedAmount", Number(amt || 0).toFixed(2), {
      shouldDirty: false,
      shouldValidate: false,
    });
    setValue("receivedAmountAed", Number(aed || 0).toFixed(2), {
      shouldDirty: false,
      shouldValidate: false,
    });
    setRcvAmountAed(aed);
  }, [transferAmount, exchangeRateUsd, selectedTransactionType, setValue]);

  const handleUploadInvoice = async (file, docs) => {
    setProgress(0);
    try {
      const formData = new FormData();
      formData.append("document", file);
      const { data } = await instance.post(routes.uploadDocuments, formData, {
        onUploadProgress: (progressEvent) => {
          const uploadedBytes = progressEvent.loaded;
          const percentCompleted = Math.round(
            (uploadedBytes * 100) / progressEvent.total,
          );

          setProgress(percentCompleted);
          setUploadedSize(getFileSize(uploadedBytes));
        },
      });
      if (data) {
        docs[0].isUpload = true;
        docs[0].file = data?.data?.nations;
        setDocumentDetail(docs);
        setDocumentLink(data?.data?.nations);
        SuccessToaster("Document Added");
      }
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const downloadAllAttachments = async (documentLinks) => {
    if (!documentLinks || documentLinks.trim() === "") {
      ErrorToaster("No attachments available.");
      return;
    }

    const filePath = documentLinks.trim();
    const fileUrl = `${process.env.REACT_APP_IMAGE_BASE_URL}${filePath}`;
    const fileExtension = filePath.split(".").pop();

    try {
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", `attachment.${fileExtension}`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(blobUrl); // Cleanup
      SuccessToaster("Downloading attachment...");
    } catch (error) {
      console.error("Download failed", error);
      ErrorToaster("Failed to download attachment.");
    }
  };

  const handleDeleteDocument = (id) => {
    setInvoiceList((prev) => prev.filter((d) => d.id !== id));
  };

  // *For Create Vehicle Booking
  const createIftv = async (formData) => {
    try {
      // if (selectedFromAccount?.id === selectedToAccount?.id) {
      //   ErrorToaster("Transfer account and Receiver account is same");
      //   return;
      // }

      let fromAccount = null;
      let toAccount = null;
      let cashier = false;

      if (selectedTransactionType?.name === "Wallet") {
        fromAccount = walletAccounts?.find(
          (account) => account.id === selectedWalletFrom?.id,
        );
        toAccount = walletAccounts?.find(
          (account) => account.id === selectedWalletTo?.id,
        );
      } else if (selectedTransactionType?.name === "Cash/Bank") {
        if (
          selectedBankCashType?.id === "bank guc" ||
          selectedBankCashType?.id === "bank gws"
        ) {
          fromAccount = selectedBankCashFrom;
        } else if (
          selectedBankCashType?.id === "cash guc" ||
          selectedBankCashType?.id === "cash gws"
        ) {
          fromAccount = selectedBankCashFrom;
        }

        if (
          selectedBankCashType2?.id === "bank guc" ||
          selectedBankCashType2?.id === "bank gws"
        ) {
          toAccount = selectedBankCashTo;
        } else if (
          selectedBankCashType2?.id === "cash guc" ||
          selectedBankCashType2?.id === "cash gws"
        ) {
          toAccount = selectedBankCashTo;
        }
      }
      //   fromAccount = walletAccounts?.find(
      //     (item) => item?.id == selectedWalletFrom?.id
      //   )  || bankAccounts?.find(
      //     (item) => item?.id == selectedBankCashFrom?.id
      //   ) || cashierAccounts?.find(
      //     (item) => item?.id == selectedBankCashFrom?.id
      //   );

      //   toAccount = walletAccounts?.find(
      //     (item) => item?.id == selectedWalletTo?.id
      //   ) || bankAccounts?.find(
      //     (item) => item?.id == selectedBankCashTo?.id
      //   ) || cashierAccounts?.find(
      //     (item) => item?.id == selectedBankCashTo?.id
      //   );

      // Cash/Bank transactions: mark cashier=true if either side is a Cash account.
      // (e.g. Cash → Cash should be true)
      if (selectedTransactionType?.id === "cash/bank") {
        const fromIsCash = (selectedBankCashType?.id || "").startsWith("cash");
        const toIsCash = (selectedBankCashType2?.id || "").startsWith("cash");
        cashier = fromIsCash || toIsCash;
      } else {
        cashier = false;
      }

      const formatZeroSafe = (value, decimals) => {
        const n = Number(value) || 0;
        const eps = decimals === 2 ? 0.005 : 0.0005;
        if (Math.abs(n) < eps) return Number(0).toFixed(decimals);
        return n.toFixed(decimals);
      };

      const fromCurrency = fromAccount?.currency?.toLowerCase?.();
      const toCurrency = toAccount?.currency?.toLowerCase?.();

      const amountInput =
        Number(transferAmount ?? formData?.transferAmount) || 0;
      const officialAedPerUsd = Number(exchangeRateUsd) || 0;
      const enteredRateRaw = normalizeExchangeRate(
        updateExchangeRate ?? formData?.exchangeRate,
        getStandardUsdRate(),
      );

      let computedFromAmount = amountInput;
      let computedToAmount = Number(formData?.receivedAmount) || 0;
      let computedToAmountAed = Number(formData?.receivedAmountAed) || 0;
      let computedExchangeLossAed = Number(formData?.exchangeLoss) || 0;
      let computedExchangeRate = enteredRateRaw;

      if (selectedTransactionType?.id === "cash/bank") {
        const isSameCurrency =
          Boolean(fromCurrency) &&
          Boolean(toCurrency) &&
          fromCurrency === toCurrency;

        if (isSameCurrency) {
          computedFromAmount = amountInput;
          computedToAmount = amountInput;
          computedToAmountAed =
            fromCurrency === "usd"
              ? amountInput * officialAedPerUsd
              : amountInput;
          computedExchangeLossAed = 0;
        } else if (fromCurrency === "usd" && toCurrency === "aed") {
          // USD -> AED (rate may be entered as AED/USD or USD/AED)
          const receivedAed =
            enteredRateRaw >= 1
              ? amountInput * enteredRateRaw
              : amountInput / enteredRateRaw;
          const officialAedValue = amountInput * officialAedPerUsd;
          const exchangeLossAed = officialAedValue - receivedAed;

          computedFromAmount = amountInput;
          computedToAmount = receivedAed;
          computedToAmountAed = receivedAed;
          computedExchangeLossAed = exchangeLossAed;
          computedExchangeRate = enteredRateRaw;
        } else if (fromCurrency === "aed" && toCurrency === "usd") {
          // AED -> USD (direct conversion)
          // - If rate is AED per USD (>= 1): USD = AED / rate
          // - If rate is USD per AED (< 1): USD = AED * rate
          const normalizedAedPerUsd =
            enteredRateRaw >= 1 ? enteredRateRaw : 1 / enteredRateRaw;
          const receivedUsd =
            enteredRateRaw >= 1
              ? amountInput / enteredRateRaw
              : amountInput * enteredRateRaw;

          const receivedAedAtOfficial = receivedUsd * officialAedPerUsd;
          // Keep exchange_loss non-negative for backend payload
          const exchangeLossAed = Math.abs(amountInput - receivedAedAtOfficial);

          computedFromAmount = amountInput;
          computedToAmount = receivedUsd;
          // Keep AED base as the transferred AED amount
          computedToAmountAed = amountInput;
          // Exchange loss is a positive AED variance amount.
          computedExchangeLossAed = exchangeLossAed;
          computedExchangeRate = normalizedAedPerUsd;
        }
      }

      let obj = {
        from_account_id: selectedWalletFrom?.id || selectedBankCashFrom?.id,
        to_account_id: selectedWalletTo?.id || selectedBankCashTo?.id,
        from_currency: fromAccount?.currency,
        from_amount: Number(computedFromAmount || 0).toFixed(2),
        to_currency: toAccount?.currency,
        to_amount: Number(computedToAmount || 0).toFixed(2),
        to_amount_aed: Number(computedToAmountAed || 0).toFixed(2),
        exchange_rate: String(computedExchangeRate ?? ""),
        exchange_loss: formatZeroSafe(computedExchangeLossAed, 2),
        ref_no: formData.ref,
        notes: formData.note,
        branch_id: selectedBranch?.id,
        cashier: cashier,
        date: iftvDate,
        document_link: documentLink2,
        transaction_type: selectedTransactionType?.id,
        wallet_type: selectedWalletType?.id,
        from_cash_type: selectedBankCashType?.id,
        to_cash_type: selectedBankCashType2?.id,
        new_voucher: true,
        document_name: documentDetail2?.[0]?.name,
        // voucher_documents: invoiceList.map((d) => ({
        //     id: d.id,
        //     doc_name: d.attachmentTypeName,
        //     file_path: d.documentLink2,
        // })),
      };
      setLoading(true);
      const result = await FinanceServices.createFundTransferVoucher(obj);

      if (
        result?.status === true &&
        result?.responseCode === 200 &&
        result?.data?.id
      ) {
        const voucher_id = result?.data?.id;

        const params = { voucher_id };

        // 1) Fetch full invoice list
        const { data } =
          await FinanceServices.getFundTransferVoucherDetail(params);

        if (!data) {
          console.log("No record found to upload");
          return;
        }

        // 2) Generate PDFs
        const uploadFiles = [];

        const file = await new Promise((resolve, reject) => {
          try {
            const container = document.createElement("div");
            container.style.position = "absolute";
            container.style.top = "-99999px";
            container.style.left = "-99999px";
            container.style.width = "1200px";
            document.body.appendChild(container);

            const root = createRoot(container);

            const handleDone = (pdfBlob) => {
              setTimeout(() => {
                try {
                  root.unmount();
                  container.remove();
                } catch (err) {
                  void err;
                }
                resolve(pdfBlob);
              }, 200);
            };

            root.render(
              <FundTransferVoucherInvoice
                voucherDetail={data?.voucher}
                onDone={handleDone}
              />,
            );
          } catch (err) {
            console.error("❌ PDF Generation Error", err);
            reject(err);
          }
        });

        const pdfFile =
          file instanceof Blob
            ? new File([file], `iftvVoucher-GWS-IFTV-${voucher_id}.pdf`, {
                type: "application/pdf",
              })
            : null;

        uploadFiles.push({
          voucher_id: voucher_id,
          file: pdfFile,
        });

        // 3) Upload PDFs
        const formData = new FormData();
        formData.append("invoice_type", "iftvVoucher");

        uploadFiles.forEach((file, index) => {
          formData.append(`iftv_voucher[${index}][voucher_id]`, voucher_id);
          formData.append(`iftv_voucher[${index}][file]`, file.file);
        });

        await SystemServices.uploadERPInvoices(formData);

        setLoading(false);
        SuccessToaster(result.message);
        // navigate("/fund-transfer-vouchers");
      }
      setLoading(false);
      SuccessToaster(result.message);
      reset();
      setSelectedTransactionType(null);
      setSelectedWalletFrom(null);
      setSelectedWalletTo(null);
      setDocumentLink2("");
      setSelectedWalletType(null);
      setSelectedBankCashType(null);
      setSelectedBankCashType2(null);
      setSelectedBankCashFrom(null);
      setSelectedBankCashTo(null);
      setFromAccounts([]);
      setToAccounts([]);
      setFromAccountsPage(1);
      setToAccountsPage(1);
      setFromAccountsSearch("");
      setToAccountsSearch("");
      setDocumentDetail2([]);
      setIftvDate(new Date());
      setRcvAmountAed();
      setTransferAmount();
      //   navigate("/fund-transfer-vouchers");
    } catch (error) {
      ErrorToaster(error);
    } finally {
      setLoading(false);
    }
  };

  const isSubmitDisabled =
    !selectedTransactionType || !transferAmount || transferAmount <= 0;

  const handleTransactionTypeSelect = (value) => {
    setSelectedTransactionType(value);

    if (!value) {
      setDisabledExchangeRate(true);
      setSelectedWalletType(null);
      setSelectedWalletFrom(null);
      setSelectedWalletTo(null);
      setSelectedBankCashType(null);
      setSelectedBankCashType2(null);
      setSelectedBankCashFrom(null);
      setSelectedBankCashTo(null);
      setFromAccounts([]);
      setToAccounts([]);
      setFromAccountsPage(1);
      setToAccountsPage(1);
      setFromAccountsSearch("");
      setToAccountsSearch("");
      setValue("exchangeRate", "");
      return;
    }

    setUpdateExchangeRate(exchangeRateUsd);
    setValue("exchangeRate", exchangeRateUsd);

    if (value.id === "cash/bank") {
      setDisabledExchangeRate(false);
      return;
    }

    setDisabledExchangeRate(true);
  };

  return (
    <Box
      className="your-component-container"
      sx={{
        m: 4,
        p: 5,
      }}
    >
      {loader && (
        <div className="bookingoverlay">
          {" "}
          <CircularProgress />{" "}
        </div>
      )}

      <Box component="form" onSubmit={handleSubmit(createIftv)}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
            <Typography
              variant="h5"
              sx={{
                fontFamily: "Helvetica",
                fontSize: "27px",
                fontWeight: 700,
                fontStyle: "Bold",
              }}
            >
              Create IFTV V2
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Grid container spacing={2} sx={{ mt: 0 }}>
              <Grid item xs={12} sm={4}>
                <SelectField
                  label={"Transaction Type:"}
                  options={[
                    {
                      id: "cash/bank",
                      name: "Cash/Bank",
                    },
                    {
                      id: "wallet",
                      name: "Wallet",
                    },
                  ]}
                  selected={selectedTransactionType}
                  onSelect={handleTransactionTypeSelect}
                  error={errors?.customer?.message}
                  register={register("transType", {
                    required: "Please select transaction type.",
                  })}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <DatePicker
                  label={"Date*"}
                  value={iftvDate}
                  error={errors?.iftvDate?.message}
                  register={register("iftvDate", {
                    // required: "Please select iftv date",
                  })}
                  onChange={(date) => handleIftvDate(date)}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <InputField
                  label={"REFERENCE NO*"}
                  placeholder={"Enter Reference No"}
                  error={errors?.ref?.message}
                  register={register("ref", {
                    required: "Please select reference.",
                  })}
                />
              </Grid>

              <Grid item xs={12} sm={3}>
                <SelectField
                  size={"small"}
                  label={"Branch"}
                  options={branches}
                  selected={selectedBranch}
                  onSelect={(value) => setSelectedBranch(value)}
                  error={errors?.branch?.message}
                  register={register("branch", {
                    required: "Please select branch.",
                  })}
                />
              </Grid>

              {selectedTransactionType?.name === "Wallet" && (
                <>
                  <Grid item xs={12} sm={12}>
                    <Typography
                      sx={{
                        fontSize: "20px",
                        fontFamily: "Helvetica",
                        fontWeight: 700,
                        fontStyle: "Bold",
                      }}
                    >
                      Select Payment Type
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <SelectField
                      label={"Wallet Type"}
                      options={[
                        {
                          id: "vehicle to vehicle",
                          name: "Vehicle to Vehicle",
                        },
                        {
                          id: "shipping to shipping",
                          name: "Shipping to Shipping",
                        },
                        {
                          id: "vehicle to shipping",
                          name: "Vehicle to Shipping",
                        },
                        {
                          id: "shipping to vehicle",
                          name: "Shipping to Vehicle",
                        },
                      ]}
                      selected={selectedWalletType}
                      onSelect={(value) => {
                        setSelectedWalletType(value);
                        setSelectedWalletFrom("");
                        setSelectedWalletTo("");
                      }}
                      error={errors?.walletType?.message}
                      register={register("walletType", {
                        required: "Please select wallet type.",
                      })}
                    />
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <SelectField
                      label={"From"}
                      options={filteredWalletFromAccounts}
                      filterLimit={100}
                      selected={selectedWalletFrom}
                      onSelect={(value) => {
                        setSelectedWalletFrom(value);
                      }}
                      error={errors?.walletTo?.message}
                      register={register("walletFrom", {
                        required: "Please select wallet type.",
                      })}
                    />
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <SelectField
                      label={"To"}
                      options={filteredWalletToAccounts}
                      filterLimit={100}
                      selected={selectedWalletTo}
                      onSelect={(value) => {
                        setSelectedWalletTo(value);
                      }}
                      error={errors?.walletFrom?.message}
                      register={register("walletTo", {
                        required: "Please select wallet type.",
                      })}
                    />
                  </Grid>
                </>
              )}

              {selectedTransactionType?.name === "Cash/Bank" && (
                <>
                  <Grid item xs={12} sm={12}>
                    <Typography
                      sx={{
                        fontSize: "20px",
                        fontFamily: "Helvetica",
                        fontWeight: 700,
                        fontStyle: "Bold",
                      }}
                    >
                      Select Payment Type
                    </Typography>
                  </Grid>
                  <Grid container spacing={2} sx={{ mt: 0 }}>
                    <Grid item xs={5} sm={5}>
                      <Grid item xs={12} sm={9} sx={{ ml: 2 }}>
                        <SelectField
                          label={"Cash/Bank"}
                          options={[
                            {
                              id: "bank guc",
                              name: "Bank GUC",
                            },
                            {
                              id: "bank gws",
                              name: "Bank GWS",
                            },
                            {
                              id: "cash guc",
                              name: "Cash GUC",
                            },
                            {
                              id: "cash gws",
                              name: "Cash GWS",
                            },
                          ]}
                          selected={selectedBankCashType}
                          onSelect={(value) => {
                            setSelectedBankCashType(value);
                            setSelectedBankCashFrom(null);
                            setFromAccounts([]);
                            setFromAccountsPage(1);
                            setFromAccountsSearch("");
                            if (value) {
                              getPaymentAccounts({
                                page: 1,
                                search: "",
                                append: false,
                                target: "from",
                              });
                            }
                          }}
                          error={errors?.bankType?.message}
                          register={register("bankType", {
                            required: "Please select cash bank type.",
                          })}
                        />
                      </Grid>

                      <Grid item xs={12} sm={9} sx={{ ml: 2 }}>
                        <SelectField
                          label={"From"}
                          options={filteredFromAccounts}
                          loading={fromAccountsLoading}
                          selected={selectedBankCashFrom}
                          onSearch={(value) => {
                            setFromAccountsSearch(value || "");
                            getPaymentAccounts({
                              page: 1,
                              search: value || "",
                              append: false,
                              target: "from",
                            });
                          }}
                          onListboxScroll={handleAccountsScroll(loadMoreFromAccounts)}
                          onSelect={(value) => {
                            setSelectedBankCashFrom(value);
                          }}
                          error={errors?.walletFrom?.message}
                          register={register("walletFrom", {
                            required: "Please select wallet type.",
                          })}
                        />
                      </Grid>
                    </Grid>

                    <Grid item xs={1} sx={{ display: "flex" }}>
                      <Divider
                        orientation="vertical"
                        flexItem
                        sx={{ borderColor: "#B3B3B3" }}
                      />
                    </Grid>

                    <Grid item xs={5} sm={5}>
                      <Grid item xs={12} sm={8}>
                        <SelectField
                          label={"Cash/Bank"}
                          options={[
                            {
                              id: "bank guc",
                              name: "Bank GUC",
                            },
                            {
                              id: "bank gws",
                              name: "Bank GWS",
                            },
                            {
                              id: "cash guc",
                              name: "Cash GUC",
                            },
                            {
                              id: "cash gws",
                              name: "Cash GWS",
                            },
                          ]}
                          selected={selectedBankCashType2}
                          onSelect={(value) => {
                            setSelectedBankCashType2(value);
                            setSelectedBankCashTo(null);
                            setToAccounts([]);
                            setToAccountsPage(1);
                            setToAccountsSearch("");
                            if (value) {
                              getPaymentAccounts({
                                page: 1,
                                search: "",
                                append: false,
                                target: "to",
                              });
                            }
                          }}
                          error={errors?.bankType2?.message}
                          register={register("bankType2", {
                            required: "Please select cash bank type.",
                          })}
                        />
                      </Grid>

                      <Grid item xs={12} sm={8}>
                        <SelectField
                          label={"To"}
                          options={filteredToAccounts}
                          loading={toAccountsLoading}
                          selected={selectedBankCashTo}
                          onSearch={(value) => {
                            setToAccountsSearch(value || "");
                            getPaymentAccounts({
                              page: 1,
                              search: value || "",
                              append: false,
                              target: "to",
                            });
                          }}
                          onListboxScroll={handleAccountsScroll(loadMoreToAccounts)}
                          onSelect={(value) => {
                            setSelectedBankCashTo(value);
                          }}
                          error={errors?.walletTo?.message}
                          register={register("walletTo", {
                            required: "Please select wallet type.",
                          })}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </>
              )}
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Divider sx={{ my: 2, borderColor: "#B3B3B3" }} />
        </Grid>

        <Grid item xs={12}>
          <Grid container spacing={2} sx={{ mt: 0 }}>
            {selectedTransactionType?.name === "Wallet" ? (
              <>
                <Grid item xs={12} sm={12}>
                  <Typography
                    sx={{
                      fontSize: "20px",
                      fontFamily: "Helvetica",
                      fontWeight: 700,
                      fontStyle: "Bold",
                    }}
                  >
                    Add Amount Details $
                  </Typography>
                </Grid>
              </>
            ) : (
              <>
                <Grid item xs={12} sm={12}>
                  <Typography
                    sx={{
                      fontSize: "20px",
                      fontFamily: "Helvetica",
                      fontWeight: 700,
                      fontStyle: "Bold",
                    }}
                  >
                    Add Amount Details
                  </Typography>
                </Grid>
              </>
            )}

            <Grid item xs={12} sm={4}>
              <InputField
                size={"small"}
                label={"Transfer Amount"}
                placeholder={"Amount"}
                error={errors?.transferAmount?.message}
                register={register("transferAmount", {
                  required: "Please enter transfer amount",
                  onChange: (e) => {
                    const priceAmount = e.target.value;
                    if (
                      !(
                        !priceAmount ||
                        priceAmount.match(/^\d{1,}(\.\d{0,2})?$/)
                      )
                    ) {
                      setValue(
                        "transferAmount",
                        parseFloat(getValues("transferAmount")).toFixed(2),
                      );
                    }
                    setTransferAmount(e.target.value);
                    setRcvAmountAed(e.target.value * exchangeRateUsd);
                  },
                })}
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <InputField
                disabled={true}
                size={"small"}
                label={"Received Amount"}
                placeholder={"Received Amount"}
                register={register("receivedAmount")}
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <InputField
                error={errors?.exchangeRate?.message}
                disabled={disabledExchangeRate}
                size={"small"}
                label={"Exchange Rate"}
                placeholder={"Exchange Rate"}
                defaultValue={String(updateExchangeRate)}
                register={register("exchangeRate", {
                  validate: (value) =>
                    Number(value) > 0 || "Exchange rate must be greater than 0",
                  onChange: (e) => {
                    if (!disabledExchangeRate) {
                      setUpdateExchangeRate(e.target.value);
                    }
                  },
                  onBlur: (e) => {
                    if (!disabledExchangeRate) {
                      syncExchangeRateValue(e.target.value);
                    }
                  },
                })}
              />
            </Grid>
            {selectedTransactionType?.id === "wallet" ? (
              <>
                <Grid item xs={12} sm={4}>
                  <InputField
                    // disabled={true}
                    size={"small"}
                    label={"Received Amount(AED)"}
                    placeholder={"Received Amount(AED)"}
                    value={parseFloat(rcvAmountAed).toFixed(2)}
                    inputProps={{ readOnly: true }}
                    register={register("receivedAmountAed")}
                  />
                </Grid>
              </>
            ) : (
              <>
                <Grid item xs={12} sm={4}>
                  <InputField
                    disabled={true}
                    size={"small"}
                    label={"Exchange Loss"}
                    placeholder={"Exchange Gain/Loss"}
                    register={register("exchangeLoss")}
                  />
                </Grid>
              </>
            )}

            <Grid item xs={12} sm={8}>
              <InputField
                label={"Note"}
                placeholder={"Add Note..."}
                register={register("note")}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Divider sx={{ my: 2, borderColor: "#B3B3B3" }} />
        </Grid>

        <Grid item xs={12}>
          <Grid container spacing={2} sx={{ mt: 0 }}>
            {/* <Grid item xs={12} sm={3}>
                            <SelectField
                                label="Attachment Type"
                                options={[{
                                    id: 1, name: "doc1"
                                }, {
                                    id: 2, name: "doc2"

                                }]}
                                selected={attachmentType}
                                onSelect={(value) => {
                                    setAttachmentType(value);

                                }}
                                // error={errors?.attachmentType?.message}
                                register={register("attachmentType", {
                                    // required: "Please select invoice.",
                                })}
                            />

                        </Grid> */}

            <Grid item xs={12} sm={3} mt={3.7}>
              <UploadFile
                custom={true}
                vendor={true}
                style={{
                  backgroundColor: "#e7efeb",
                  width: "100%",
                  height: "40px",
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "20px",
                  border: "1px dashed #aeb1b0",
                  borderRadius: "10px",
                }}
                register={register("scanned", {
                  onChange: (e) => handleUploadDocumentInvoices(e),
                })}
              />
            </Grid>
            {/* <Grid item xs={12} sm={1} sx={{ textAlign: "right" }} mt={4}>
                            <IconButton
                                size="small"
                                onClick={handleAddDocument}
                                sx={{
                                    bgcolor: Colors.primary,
                                    color: Colors.white,
                                    "&:hover": {
                                        bgcolor: Colors.primary,
                                        color: Colors.white,
                                    },
                                }}
                            >
                                <Add />
                            </IconButton>
                        </Grid> */}

            {documentDetail2.length > 0 ? (
              <>
                <Grid item xs={12} sm={12}>
                  <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="Documents Table">
                      <TableHead
                        sx={{ bgcolor: Colors.primary, color: Colors.white }}
                      >
                        <TableRow>
                          <Cell>File Name</Cell>
                          <Cell>Attachment</Cell>
                          {/* <Cell>Action</Cell> */}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {/* {documentDetail2.map((doc) => ( */}
                        <TableRow>
                          <TableCell>{documentDetail2?.[0]?.name}</TableCell>
                          <TableCell>
                            {documentLink2 ? (
                              <div
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  downloadAllAttachments(documentLink2)
                                }
                              >
                                <FiDownload color={Colors.primary} size={25} />
                              </div>
                            ) : (
                              <FiDownload color="gray" size={25} />
                            )}
                          </TableCell>
                          {/* <TableCell>
                                                                <IconButton
                                                                    aria-label="delete document"
                                                                    onClick={() => handleDeleteDocument(doc.id)}
                                                                    sx={{ color: Colors.danger }}
                                                                >
                                                                    <DeleteIcon />
                                                                </IconButton>
                                                            </TableCell> */}
                        </TableRow>
                        {/* ))} */}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
              </>
            ) : (
              <></>
            )}
          </Grid>
        </Grid>
        {/* <Grid item xs={12} ml={2} mr={2}>
                    <Divider sx={{ my: 2, borderColor: "#B3B3B3" }} />
                </Grid> */}

        {/* Sticky footer submit */}
        <Box
          sx={{
            bottom: 0,
            pt: 2,
            mt: 2,
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
            <PrimaryButton
              title="Submit"
              type="submit"
              loading={loading}
              disabled={isSubmitDisabled}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default CreateIftv2;
